/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';

/**
 * PageName: HOME
 */
export const HomePageLog = {
  PopupHome: {
    /**
     * 홈 화면 전면 팝업 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L4}
     * HomePopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L9}
     */
    impression({ popupSize, btnName, popupId, title }: HomePageLog.PopupHome.Impression) {
      return KinesisTracker.impression('HOME', {
        clientEventId: 46,
        pageName: 'PAGE_NAME_HOME',
        object: 'homePopup',
        objectContainer: 'homePopup',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        popupSize,
        btnName,
        popupId,
        title,
      });
    },
  },

  HomePopupButtonCloseBtn: {
    /**
     * 홈 화면 전면 팝업 클릭 - 닫기버튼
     * object_container를 노출/클릭에 모두 넣은 이유는 클릭의 경우 남지 않으면, 이 클릭이 어디서 발생한지 알기 어렵기 때문이다.
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L16}
     * HomePopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L9}
     */
    click({ popupSize, btnName, popupId, title }: HomePageLog.HomePopupButtonCloseBtn.Click) {
      return KinesisTracker.click('HOME', {
        clientEventId: 47,
        pageName: 'PAGE_NAME_HOME',
        object: 'closeBtn',
        objectContainer: 'homePopup',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        popupSize,
        btnName,
        popupId,
        title,
      });
    },
  },

  HomePopupButtonAvoidBtn: {
    /**
     * 홈 화면 전면 팝업 클릭 - 다시 보지 않기 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L29}
     * HomePopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L9}
     */
    click({ popupSize, btnName, popupId, title }: HomePageLog.HomePopupButtonAvoidBtn.Click) {
      return KinesisTracker.click('HOME', {
        clientEventId: 48,
        pageName: 'PAGE_NAME_HOME',
        object: 'avoidBtn',
        objectContainer: 'homePopup',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        popupSize,
        btnName,
        popupId,
        title,
      });
    },
  },

  HomePopupButtonBtn: {
    /**
     * 홈 화면 전면 팝업 클릭 - 기타 버튼 (상세로 넘어가는 버튼 또는 추가될 경우!)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L41}
     * HomePopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L9}
     */
    click({ popupSize, btnName, popupId, title }: HomePageLog.HomePopupButtonBtn.Click) {
      return KinesisTracker.click('HOME', {
        clientEventId: 49,
        pageName: 'PAGE_NAME_HOME',
        object: 'Btn',
        objectContainer: 'homePopup',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        popupSize,
        btnName,
        popupId,
        title,
      });
    },
  },

  HeaderAnimatedImageDeusBiId: {
    /**
     * 홈 화면 BI영역 - 노출
     * 참고 : https://screen.yanolja.in/MBwdqO0KFWxtBcWF
     *deus에서 propertyid를 뜻한다.  참고 테이블: t1_db_deus_deus.normalized_widgets의 id값
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L79}
     */
    impression({ deusBiId }: HomePageLog.HeaderAnimatedImageDeusBiId.Impression) {
      return KinesisTracker.impression('HOME', {
        clientEventId: 52,
        pageName: 'PAGE_NAME_HOME',
        object: deusBiId,
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_ANIMATED_IMAGE',
        eventType: 'EVENT_TYPE_IMPR',
      });
    },

    /**
     * 홈 화면 BI영역 - 클릭
     * 참고 : https://screen.yanolja.in/MBwdqO0KFWxtBcWF
     *deus에서 propertyid를 뜻한다. 참고 테이블: t1_db_deus_deus.normalized_widgets의 id값
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L90}
     */
    click({ deusBiId }: HomePageLog.HeaderAnimatedImageDeusBiId.Click) {
      return KinesisTracker.click('HOME', {
        clientEventId: 53,
        pageName: 'PAGE_NAME_HOME',
        object: deusBiId,
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_ANIMATED_IMAGE',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  FloatingButtonReservationCard: {
    /**
     * 홈 화면 예약카드 - 노출
     * 다가오는 예약이 있는 사용자에게 노출되는 것, 이를 통해 check 목적과 가격확인 사용자 유추가 가능할 것.,
     *참고 : https://screen.yanolja.in/og7qAVOczkJK7PZo, 구글 스프레드 1,280행에 이미 존재
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L101}
     */
    impression({}: HomePageLog.FloatingButtonReservationCard.Impression = {}) {
      return KinesisTracker.impression('HOME', {
        clientEventId: 54,
        pageName: 'PAGE_NAME_HOME',
        object: 'reservationCard',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
      });
    },

    /**
     * 홈 화면 예약카드 - 클릭
     * 참고: https://screen.yanolja.in/og7qAVOczkJK7PZo, 구글 스프레드 493행에 미이 존재
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L112}
     */
    click({}: HomePageLog.FloatingButtonReservationCard.Click = {}) {
      return KinesisTracker.click('HOME', {
        clientEventId: 55,
        pageName: 'PAGE_NAME_HOME',
        object: 'reservationCard',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  WidgetIdBannerItem: {
    /**
     * 홈 - 각종 (모든 유형) 배너 - 노출
     * 참고 : https://screen.yanolja.in/Z2wx7svl9GzfbpEo
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L122}
     * BannerCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L23}
     */
    impression({ widgetId, itemId, widgetPosition, itemPosition }: HomePageLog.WidgetIdBannerItem.Impression) {
      return KinesisTracker.impression('HOME', {
        clientEventId: 56,
        pageName: 'PAGE_NAME_HOME',
        object: itemId,
        objectContainer: widgetId,
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        widgetId,
        itemId,
        widgetPosition,
        itemPosition,
      });
    },

    /**
     * 홈 - 각종 (모든 유형) 배너 - 클릭
     * 참고: https://screen.yanolja.in/Z2wx7svl9GzfbpEo
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L134}
     * BannerCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L23}
     */
    click({ widgetId, itemId, widgetPosition, itemPosition }: HomePageLog.WidgetIdBannerItem.Click) {
      return KinesisTracker.click('HOME', {
        clientEventId: 57,
        pageName: 'PAGE_NAME_HOME',
        object: itemId,
        objectContainer: widgetId,
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        widgetId,
        itemId,
        widgetPosition,
        itemPosition,
      });
    },
  },

  QuickCategoryBoardRowItem: {
    /**
     * 홈 - 퀵카테고리 - 노출
     * 참고: https://screen.yanolja.in/qpf3bdVKjTPZ5zLx
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L146}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    impression({ widgetPosition, position, logMeta }: HomePageLog.QuickCategoryBoardRowItem.Impression) {
      return KinesisTracker.impression('HOME', {
        clientEventId: 58,
        pageName: 'PAGE_NAME_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_IMPR',
        widgetPosition,
        position,
        ...logMeta,
      });
    },

    /**
     * 홈 - 퀵카테고리 - 클릭
     * 참고: https://screen.yanolja.in/qpf3bdVKjTPZ5zLx
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L159}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    click({ widgetPosition, position, logMeta }: HomePageLog.QuickCategoryBoardRowItem.Click) {
      return KinesisTracker.click('HOME', {
        clientEventId: 59,
        pageName: 'PAGE_NAME_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_CLICK',
        widgetPosition,
        position,
        ...logMeta,
      });
    },
  },

  PromotionTallBannerSwipeId: {
    /**
     * 홈 - 노출 - 프로모션 세로형 배너 위젯 내 - 배너 아이템
     * # 참조하는 SQL: https://screen.yanolja.in/If4fUoYc1WJ8jWBt
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L217}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/promotion_tall_banner_swipe_v2.proto#L0}
     */
    impression({ logMeta }: HomePageLog.PromotionTallBannerSwipeId.Impression) {
      return KinesisTracker.impression('HOME', {
        inactive: false,
        widget_name: 'promotionTallBannerSwipe',
        clientEventId: 677,
        pageName: 'PAGE_NAME_HOME',
        object: 'bannerId',
        objectContainer: 'promotionTallBannerSwipe',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * 홈 - 클릭 - 프로모션 세로형 배너 위젯 내 -  배너 아이템
     * # 참조하는 SQL: https://screen.yanolja.in/If4fUoYc1WJ8jWBt
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L231}
     * PromotionTallBannerSwipeV2Banner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/promotion_tall_banner_swipe_v2.proto#L0}
     */
    click({ logMeta }: HomePageLog.PromotionTallBannerSwipeId.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'promotionTallBannerSwipe',
        clientEventId: 678,
        pageName: 'PAGE_NAME_HOME',
        object: 'bannerId',
        objectContainer: 'promotionTallBannerSwipe',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  PromotionTallBannerSwipeButtonSeeAll: {
    /**
     * 홈 - 클릭 - 프로모션 세로형 배너 위젯 내 -  전체보기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L245}
     * PromotionTallBannerSwipeV2SeeAllButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/promotion_tall_banner_swipe_v2.proto#L0}
     */
    click({ logMeta }: HomePageLog.PromotionTallBannerSwipeButtonSeeAll.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'promotionTallBannerSwipe',
        clientEventId: 679,
        pageName: 'PAGE_NAME_HOME',
        object: 'seeAll',
        objectContainer: 'promotionTallBannerSwipe',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  CuratedTicketEmbeddedWidgetCardId: {
    /**
     * 홈 - 노출 - 놀티켓 용 큐레이션 위젯 내 - 아이템(상품)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L259}
     * CuratedTicketEmbeddedWidgetProductItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/curated_ticket_embedded_widget.proto#L0}
     */
    impression({ logMeta }: HomePageLog.CuratedTicketEmbeddedWidgetCardId.Impression) {
      return KinesisTracker.impression('HOME', {
        inactive: false,
        widget_name: 'CuratedTicketEmbeddedWidget',
        clientEventId: 680,
        pageName: 'PAGE_NAME_HOME',
        object: 'id',
        objectContainer: 'CuratedTicketEmbeddedWidget',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * 홈 - 클릭 - 놀티켓 용 큐레이션 위젯 내 - 아이템(상품)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L273}
     * CuratedTicketEmbeddedWidgetProductItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/curated_ticket_embedded_widget.proto#L0}
     */
    click({ logMeta }: HomePageLog.CuratedTicketEmbeddedWidgetCardId.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'CuratedTicketEmbeddedWidget',
        clientEventId: 681,
        pageName: 'PAGE_NAME_HOME',
        object: 'id',
        objectContainer: 'CuratedTicketEmbeddedWidget',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  CuratedTicketEmbeddedWidgetLabelNol: {
    /**
     * 홈 - 클릭 - 놀티켓 용 큐레이션 위젯 내 - 놀티켓 로고
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L287}
     * CuratedTicketEmbeddedWidgetLogoItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/curated_ticket_embedded_widget.proto#L0}
     */
    click({ logMeta }: HomePageLog.CuratedTicketEmbeddedWidgetLabelNol.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'CuratedTicketEmbeddedWidget',
        clientEventId: 682,
        pageName: 'PAGE_NAME_HOME',
        object: 'nolTicket',
        objectContainer: 'CuratedTicketEmbeddedWidget',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  CuratedTicketEmbeddedWidgetIconCategoryTitle: {
    /**
     * 홈 - 클릭 - 놀티켓 용 큐레이션 위젯 내 - 카테고리
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L301}
     * CuratedTicketEmbeddedWidgetCategoryItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/curated_ticket_embedded_widget.proto#L0}
     */
    click({ logMeta }: HomePageLog.CuratedTicketEmbeddedWidgetIconCategoryTitle.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'CuratedTicketEmbeddedWidget',
        clientEventId: 683,
        pageName: 'PAGE_NAME_HOME',
        object: 'categoryTitle',
        objectContainer: 'CuratedTicketEmbeddedWidget',
        objectType: 'OBJECT_TYPE_ICON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  WidgetTabTitleCardId: {
    /**
     * 홈 - 노출 - 놀티켓 랭킹 위젯 내 - 아이템(상품)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L315}
     * CategoryFilteredTicketRankingV1WidgetProductItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/category_filtered_ticket_ranking_v1.proto#L0}
     */
    impression({ logMeta }: HomePageLog.WidgetTabTitleCardId.Impression) {
      return KinesisTracker.impression('HOME', {
        inactive: false,
        widget_name: 'ticketRankingWidget',
        clientEventId: 684,
        pageName: 'PAGE_NAME_HOME',
        object: 'id',
        objectContainer: 'widgetTabTitle',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * 홈 - 클릭 - 놀티켓 랭킹 위젯 내 - 아이템(상품)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L329}
     * CategoryFilteredTicketRankingV1WidgetProductItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/category_filtered_ticket_ranking_v1.proto#L0}
     */
    click({ logMeta }: HomePageLog.WidgetTabTitleCardId.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'ticketRankingWidget',
        clientEventId: 685,
        pageName: 'PAGE_NAME_HOME',
        object: 'id',
        objectContainer: 'widgetTabTitle',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  TabWidgetTitle: {
    /**
     * 홈 - 클릭 - 놀티켓 랭킹 위젯 내 - 탭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L343}
     * CategoryFilteredTicketRankingV1WidgetTab
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/category_filtered_ticket_ranking_v1.proto#L0}
     */
    click({ logMeta }: HomePageLog.TabWidgetTitle.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'ticketRankingWidget',
        clientEventId: 686,
        pageName: 'PAGE_NAME_HOME',
        object: 'widgetTabTitle',
        objectType: 'OBJECT_TYPE_TAB',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  WidgetTabTitleButtonSeeAll: {
    /**
     * 홈 - 클릭 - 놀티켓 랭킹 위젯 내 - 전체보기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L356}
     * CategoryFilteredTicketRankingV1WidgetSeeAllButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/category_filtered_ticket_ranking_v1.proto#L0}
     */
    click({ logMeta }: HomePageLog.WidgetTabTitleButtonSeeAll.Click) {
      return KinesisTracker.click('HOME', {
        inactive: false,
        widget_name: 'ticketRankingWidget',
        clientEventId: 687,
        pageName: 'PAGE_NAME_HOME',
        object: 'seeAll',
        objectContainer: 'widgetTabTitle',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace HomePageLog {
  export namespace PopupHome {
    /**
     */
    export interface Impression {
      /* 팝업 사이즈 유형 - 우선 당장 2가지뿐이라 enum으로 접근하지 않았음*/
      popupSize: string;
      /* 팝업에서 다시보지않기/닫기 외에 버튼이 있을 경우 그 버튼 명 (이벤트 정의에서는 object가 Btn으로 남기 때문에)*/
      btnName?: string;
      /* 팝업 id로, deus*/
      popupId: string;
      /* 팝업 주제 eg.해외여행 야놀자로 떠나용!*/
      title: string;
    }
  }
  export namespace HomePopupButtonCloseBtn {
    /**
     * object_container를 노출/클릭에 모두 넣은 이유는 클릭의 경우 남지 않으면, 이 클릭이 어디서 발생한지 알기 어렵기 때문이다.
     */
    export interface Click {
      /* 팝업 사이즈 유형 - 우선 당장 2가지뿐이라 enum으로 접근하지 않았음*/
      popupSize: string;
      /* 팝업에서 다시보지않기/닫기 외에 버튼이 있을 경우 그 버튼 명 (이벤트 정의에서는 object가 Btn으로 남기 때문에)*/
      btnName?: string;
      /* 팝업 id로, deus*/
      popupId: string;
      /* 팝업 주제 eg.해외여행 야놀자로 떠나용!*/
      title: string;
    }
  }
  export namespace HomePopupButtonAvoidBtn {
    /**
     */
    export interface Click {
      /* 팝업 사이즈 유형 - 우선 당장 2가지뿐이라 enum으로 접근하지 않았음*/
      popupSize: string;
      /* 팝업에서 다시보지않기/닫기 외에 버튼이 있을 경우 그 버튼 명 (이벤트 정의에서는 object가 Btn으로 남기 때문에)*/
      btnName?: string;
      /* 팝업 id로, deus*/
      popupId: string;
      /* 팝업 주제 eg.해외여행 야놀자로 떠나용!*/
      title: string;
    }
  }
  export namespace HomePopupButtonBtn {
    /**
     */
    export interface Click {
      /* 팝업 사이즈 유형 - 우선 당장 2가지뿐이라 enum으로 접근하지 않았음*/
      popupSize: string;
      /* 팝업에서 다시보지않기/닫기 외에 버튼이 있을 경우 그 버튼 명 (이벤트 정의에서는 object가 Btn으로 남기 때문에)*/
      btnName?: string;
      /* 팝업 id로, deus*/
      popupId: string;
      /* 팝업 주제 eg.해외여행 야놀자로 떠나용!*/
      title: string;
    }
  }
  export namespace HeaderAnimatedImageDeusBiId {
    /**
     * 참고 : https://screen.yanolja.in/MBwdqO0KFWxtBcWF
     *deus에서 propertyid를 뜻한다.  참고 테이블: t1_db_deus_deus.normalized_widgets의 id값
     */
    export interface Impression {
      deusBiId: string;
    }

    /**
     * 참고 : https://screen.yanolja.in/MBwdqO0KFWxtBcWF
     *deus에서 propertyid를 뜻한다. 참고 테이블: t1_db_deus_deus.normalized_widgets의 id값
     */
    export interface Click {
      deusBiId: string;
    }
  }
  export namespace FloatingButtonReservationCard {
    /**
     * 다가오는 예약이 있는 사용자에게 노출되는 것, 이를 통해 check 목적과 가격확인 사용자 유추가 가능할 것.,
     *참고 : https://screen.yanolja.in/og7qAVOczkJK7PZo, 구글 스프레드 1,280행에 이미 존재
     */
    export interface Impression {}

    /**
     * 참고: https://screen.yanolja.in/og7qAVOczkJK7PZo, 구글 스프레드 493행에 미이 존재
     */
    export interface Click {}
  }
  export namespace WidgetIdBannerItem {
    /**
     * 참고 : https://screen.yanolja.in/Z2wx7svl9GzfbpEo
     */
    export interface Impression {
      /* ydm 시스템에 등록되어 있는 widget_id - 여기서는 배너위젯의 아이디.*/
      widgetId: string;
      /* ydm 시스템에 등록 되어 있는 item id - 여기서는 배너위젯 내 개별 배너들의 아이디일 것.*/
      itemId: string;
      /* 화면 내에서 위젯 위치*/
      widgetPosition: number;
      /* 배너 위젯 내 아이템 위치 -- 단일형이어서 배너 위젯내 1개의 배너 아이템만 존재할 경우 안 남을 수도 있다.*/
      itemPosition?: number;
    }

    /**
     * 참고: https://screen.yanolja.in/Z2wx7svl9GzfbpEo
     */
    export interface Click {
      /* ydm 시스템에 등록되어 있는 widget_id - 여기서는 배너위젯의 아이디.*/
      widgetId: string;
      /* ydm 시스템에 등록 되어 있는 item id - 여기서는 배너위젯 내 개별 배너들의 아이디일 것.*/
      itemId: string;
      /* 화면 내에서 위젯 위치*/
      widgetPosition: number;
      /* 배너 위젯 내 아이템 위치 -- 단일형이어서 배너 위젯내 1개의 배너 아이템만 존재할 경우 안 남을 수도 있다.*/
      itemPosition?: number;
    }
  }
  export namespace QuickCategoryBoardRowItem {
    /**
     * 참고: https://screen.yanolja.in/qpf3bdVKjTPZ5zLx
     */
    export interface Impression {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * 참고: https://screen.yanolja.in/qpf3bdVKjTPZ5zLx
     */
    export interface Click {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace PromotionTallBannerSwipeId {
    /**
     * # 참조하는 SQL: https://screen.yanolja.in/If4fUoYc1WJ8jWBt
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * # 참조하는 SQL: https://screen.yanolja.in/If4fUoYc1WJ8jWBt
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace PromotionTallBannerSwipeButtonSeeAll {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace CuratedTicketEmbeddedWidgetCardId {
    /**
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace CuratedTicketEmbeddedWidgetLabelNol {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace CuratedTicketEmbeddedWidgetIconCategoryTitle {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace WidgetTabTitleCardId {
    /**
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace TabWidgetTitle {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace WidgetTabTitleButtonSeeAll {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}

/**
 * PageName: FLIGHT_HOME
 */
export const FlightHomePageLog = {
  PopupTitle: {
    /**
     * 항공 서브홈 - 각종 Alert 팝업 이벤트 - 노출
     * 스샷 : https://screen.yanolja.in/4wjzgUbFPjtb0TqN
     *custom(.proto)에 정의되어 있는데, 이것을 밖으로 빼내어 다시 표현해줄 수 있나요?
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L53}
     * FlightPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/flights.proto#L9}
     */
    impression({ popupTitle, popupClickName }: FlightHomePageLog.PopupTitle.Impression) {
      return KinesisTracker.impression('FLIGHT_HOME', {
        clientEventId: 50,
        pageName: 'PAGE_NAME_FLIGHT_HOME',
        objectContainer: popupTitle,
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        popupTitle,
        popupClickName,
      });
    },
  },

  PopupTitleButtonClickName: {
    /**
     * 항공 서브홈 - 각종 Alert 팝업 이벤트 - 클릭
     * 스샷 : https://screen.yanolja.in/4wjzgUbFPjtb0TqN
     *custom(.proto)에 정의되어 있는데, 이것을 밖으로 빼내어 다시 표현해줄 수 있나요?
     *custom(.proto)에 정의되어 있는데, 이것을 밖으로 빼내어 다시 표현해줄 수 있나요?
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L65}
     * FlightPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/flights.proto#L9}
     */
    click({ popupTitle, popupClickName }: FlightHomePageLog.PopupTitleButtonClickName.Click) {
      return KinesisTracker.click('FLIGHT_HOME', {
        clientEventId: 51,
        pageName: 'PAGE_NAME_FLIGHT_HOME',
        object: popupClickName,
        objectContainer: popupTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        popupTitle,
        popupClickName,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace FlightHomePageLog {
  export namespace PopupTitle {
    /**
     * 스샷 : https://screen.yanolja.in/4wjzgUbFPjtb0TqN
     *custom(.proto)에 정의되어 있는데, 이것을 밖으로 빼내어 다시 표현해줄 수 있나요?
     */
    export interface Impression {
      /*
       * 항공 관련 모든 팝업
       *팝업의 정보
       *팝업 제목은? eg.iOS13 이하 버전은 지원하지 않습니다.
       */
      popupTitle: string;
      /*
       * 팝업에서의 클릭 명? 클릭이벤트에만 남기 때문에 optional. 한글 그대로 남기는 것이 하드코딩이 적다면 그대로! 아니라면 영문으로?
       *eg.긍정 - 확인(confirmBtn), 저장하기(confirmBtn),
       *eg.부정 - 아니요(disagreeBtn), 그만하기(disagreeBtn)
       */
      popupClickName?: string;
    }
  }
  export namespace PopupTitleButtonClickName {
    /**
     * 스샷 : https://screen.yanolja.in/4wjzgUbFPjtb0TqN
     *custom(.proto)에 정의되어 있는데, 이것을 밖으로 빼내어 다시 표현해줄 수 있나요?
     *custom(.proto)에 정의되어 있는데, 이것을 밖으로 빼내어 다시 표현해줄 수 있나요?
     */
    export interface Click {
      /*
       * 항공 관련 모든 팝업
       *팝업의 정보
       *팝업 제목은? eg.iOS13 이하 버전은 지원하지 않습니다.
       */
      popupTitle: string;
      /*
       * 팝업에서의 클릭 명? 클릭이벤트에만 남기 때문에 optional. 한글 그대로 남기는 것이 하드코딩이 적다면 그대로! 아니라면 영문으로?
       *eg.긍정 - 확인(confirmBtn), 저장하기(confirmBtn),
       *eg.부정 - 아니요(disagreeBtn), 그만하기(disagreeBtn)
       */
      popupClickName?: string;
    }
  }
}

/**
 * PageName: CATEGORY_OVERVIEW
 */
export const CategoryOverviewPageLog = {
  Unspecified: {
    /**
     * 홈 - 전체 카테고리 - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L172}
     */
    view({}: CategoryOverviewPageLog.Unspecified.View = {}) {
      return KinesisTracker.view('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 669,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        eventType: 'EVENT_TYPE_VIEW',
      });
    },
  },

  ButtonCategoryTitle: {
    /**
     * 홈 - 전체 카테고리 - 클릭 - 버튼 - 상품유형(대분류)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L181}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/home/category_overview.proto#L0}
     */
    click({ logMeta }: CategoryOverviewPageLog.ButtonCategoryTitle.Click) {
      return KinesisTracker.click('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 671,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        object: 'CategoryTitle',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  CategoryTitleButtonSub: {
    /**
     * 홈 - 전체 카테고리 - 클릭 - 버튼 - 상품유형(중분류)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L193}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/home/category_overview.proto#L0}
     */
    click({ logMeta }: CategoryOverviewPageLog.CategoryTitleButtonSub.Click) {
      return KinesisTracker.click('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 672,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        object: 'subCategoryTitle',
        objectContainer: 'categoryTitle',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ButtonSearch: {
    /**
     * 홈 - 전체 카테고리 - 클릭 - 버튼 - 검색창
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L206}
     */
    click({}: CategoryOverviewPageLog.ButtonSearch.Click = {}) {
      return KinesisTracker.click('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 673,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        object: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CategoryOverviewPageLog {
  export namespace Unspecified {
    /**
     */
    export interface View {}
  }
  export namespace ButtonCategoryTitle {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace CategoryTitleButtonSub {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace ButtonSearch {
    /**
     */
    export interface Click {}
  }
}
